import { createFormAction } from 'redux-form-saga'
export const FORM_KEY = 'FEEDBACK_FORM'
export const FeedbackFormAction = createFormAction(FORM_KEY)